import { render, staticRenderFns } from "./UpgradeBottomSheet.vue?vue&type=template&id=775d3f4e&scoped=true"
import script from "./UpgradeBottomSheet.vue?vue&type=script&lang=js"
export * from "./UpgradeBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBottomSheet.vue?vue&type=style&index=0&id=775d3f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d3f4e",
  null
  
)

export default component.exports